import styled from '@emotion/styled';

interface IChatErrorMessageProps {
  noBackground?: boolean;
}
export const ChatErrorMessage = styled('div')<IChatErrorMessageProps>`
  color: #d32f2f;
  font-weight: 800;
  background-color: ${(props) => (props.noBackground ? 'unset' : '#f1c1c1')};
  line-height: 2.2rem;
  font-size: 1.2rem;
  padding: 1rem;
  position: relative;
  width: calc(100% - 2rem); /* minus padding */
  left: 0;
`;

export const WarningIcon = styled('span')`
  padding: 0.1rem 0.61rem;
  border: 0.2rem solid #D32F2F;
  border-radius: 2.5rem;

  ::before {
    content: '!';
    font-size: 1.4rem;
  }
`;

export const ErrorTitle = styled('span')`
  font-size: 1.5rem;
  padding-left: 1rem;
`;

export const ViewDetailsStyled = styled('button')`
  letter-spacing: 0.15rem;
  cursor: pointer;
  user-select: none;

  border: 0.1rem solid rgba(255, 0, 0, 0.3);
  border-radius: 6px;
  background-color: rgba(255, 0, 0, 0.1);
  margin-left: 0.8rem;
  color: inherit;
  height: 3rem;
`;

export const ErrorDetails = styled('div')`
  margin: 0.4rem 0;
  font-weight: 400;
  font-size: 1.3rem;

  animation: slide-up 0.4s ease;

  @keyframes slide-up {
    0% {
        opacity: 0;
        transform: translateX(-2.0rem);
    }
    100% {
        opacity: 1;
        transform: translateX(0);
    }
  }
`;
